import Vue from 'vue'

import departamentos from '../ubigeo/departamentos.json'
import provincias from '../ubigeo/provincias.json'
import distritos from '../ubigeo/distritos.json'

Vue.prototype.$departamentos = departamentos
Vue.prototype.$provincias = provincias
Vue.prototype.$distritos = distritos